export const apiPrefix = process.env.REACT_APP_BASE_API_PREFIX;
export const role = process.env.REACT_APP_ROLE